// import axios from 'axios'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const state = () => ({
  ui: {
    isInErrorState: false,
    clientVersion: process.env.VUE_APP_VERSION,
    loading: true,
    toastMessage: '',
    announcements: ''
  },
  user: {
    isLoggedIn: false,
    authStatus: '',
    currentUser: ''
  },
  userList: []
})

const getters = {
  loadingStatus: state => {
    return state.ui.loading
  }
}

const mutations = {
  toggleLoadingStatus (state) {
    state.ui.loading = !state.ui.loading
  },
  updateLoadingStatus (state, value) {
    state.ui.loading = value
  }
}

const actions = {}

export default {
  state,
  getters,
  actions,
  mutations
}
